import { useState, useCallback } from 'react';
import { useRestClient } from '../WebServices/useRestClient';
import type { UserDataResponse } from '../../types/api';

export interface GetFullPersonRequest {
  IdentifierRequest: {
    identifierType: number;
    identifierValue: string;
  };
}

const useGetFullPersonREST = () => {
  const callRest = useRestClient();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const [data, setData] = useState<UserDataResponse | null>(null);

  const fetchFullPerson = useCallback(
    async (params: GetFullPersonRequest) => {
      setLoading(true);
      setError(null);
      try {
        const result = await callRest<UserDataResponse>('/rest/2.0/personWebService/getFullPerson', {
          method: 'POST',
          body: params,
          useAuth: true
        });
        setData(result);
        return result;
      } catch (err) {
        const errorMessage = err instanceof Error ? err.message : 'Erreur appel REST';
        setError(errorMessage);
        throw err;
      } finally {
        setLoading(false);
      }
    },
    [callRest]
  );

  return { fetchFullPerson, loading, error, data };
};

export default useGetFullPersonREST;
